import axios from "@/axios";

export default {
  namespaced: true,
  state: {
    loading: false,
    accommodations: [],
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    accommodations(state) {
      return state.accommodations;
    },
  },
  mutations: {
    RESET(state) {
      state.loading = false;
      state.accommodations = [];
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_ACCOMMODATIONS(state, payload) {
      state.accommodations = payload;
    },
  },
  actions: {
    reset({ commit }) {
      commit("RESET");
    },
    fetchAccommodations({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        axios
          .get("/provider_accommodations?pagination=false")
          .then((response) => {
            commit("SET_ACCOMMODATIONS", response.data["hydra:member"]);
            resolve(response);
          })
          .catch((error) => {
            // TODO: Log error in Sentry
            reject(error);
          })
          .finally(() => commit("SET_LOADING", false));
      });
    },
  },
};
